import { useCallback, useEffect, useState } from "react";
import type { User } from "@dropin/shared/schemas";
import { getMe } from "../api";

export function useUser() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getMe();
      setUser(res.user);
      setError(null);
    } catch (e) {
      setUser(null);
      setError(e instanceof Error ? e : new Error("failed"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { user, loading, error, refresh, setUser };
}
